// ----------------------------------------------------------------------
// <copyright file="Izenda.OperatorValueCheckBoxPopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Checkbox Container component
 */
!(function() {
  var m = require('mobx');
  var React = require('react');
  var Popup = require('share/components/controls/CommonPopup/Izenda.Popup');
  var OverflowText = require('share/components/controls/Izenda.OverflowText');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var constants = require('logic/data/Izenda.FilterDetailsConfigConstants');
  var BLANK = constants.DEFAUFT_VALUE.BLANK;
  var ScrollBox = require('share/components/controls/Izenda.ScrollBox');
  var localizer = require('share/localization/Izenda.Localizer');
  const { without, identity, clone, includes, chunk } = require('lodash/fp');
  var OperatorValueCheckBoxPopup = React.createClass({
    propTypes: {
      filterSource: React.PropTypes.object.isRequired,
      filterInfo: React.PropTypes.object.isRequired,
      showPopup: React.PropTypes.bool,
      applyFormater: React.PropTypes.func,
      onChange: React.PropTypes.func
    },

    getInitialState: function() {
      return {
        selectedValues: null
      };
    },

    handleValueChange: function(item, data) {
      var selectedValues = this.state.selectedValues;

      if (!item.checked) {
        selectedValues.push(item.value);
      } else {
        selectedValues = without([item.value], selectedValues);
      }

      this.setState({ selectedValues: selectedValues });
    },

    onClosingPopup: function(type) {
      var props = this.props;
      if (type === 'accept') {
        props.onChange && props.onChange(this.state.selectedValues);
        this.setState({ selectedValues: null });
        props.onAccept();
      } else if (type === 'cancel') {
        this.setState({ selectedValues: null });
        props.onReject();
      }
      props.updateKeepShowingHost && props.updateKeepShowingHost(false);
    },

    populateSelectedValues: function(filterInfo) {
      filterInfo = filterInfo || {};
      var filterValues = clone(filterInfo.value);
      this.setState({
        selectedValues: filterValues
      });
    },

    componentWillMount: function() {
      this.populateSelectedValues(this.props.filterInfo);
      this.props.updateKeepShowingHost && this.props.updateKeepShowingHost(true);
    },

    /**
     * Handle when receive react property
     * @param  {object} nextProps react property
     */
    componentWillReceiveProps: function(nextProps) {
      this.populateSelectedValues(nextProps.filterInfo);
    },

    render: function() {
      var props = this.props;
      var filterValues = this.state.selectedValues || [];
      var popupTitle = this.props.operatorGroup.fieldDetails.alias;
      var source = m.toJS(props.filterSource || []);
      // add BLANK option to the first element
      source.splice(0, 0, BLANK);
      var applyFormater = this.props.applyFormater || identity;

      var data = source.map(function(value) {
        return {
          value: value,
          label: applyFormater(value),
          checked: includes(value, filterValues)
        };
      });

      var options = data.map(
        function(item, index) {
          return (
            <GridLayout.Col className='checkbox u_noMarginTop' cols={4} key={'chk-' + index}>
              <label>
                <input
                  type='checkbox'
                  value={item.value}
                  checked={item.checked}
                  onChange={this.handleValueChange.bind(this, item, data)}
                />
                <OverflowText tooltip={item.label}>{item.label}</OverflowText>
              </label>
            </GridLayout.Col>
          );
        }.bind(this)
      );

      var chunkOptions = chunk(3, options);
      const zIndex = 1061;
      return (
        <Popup
          visible
          onClosed={this.onClosingPopup}
          autoClose
          type='none'
          style={{ zIndex }}
          backdropStyle={{ zIndex: zIndex - 1 }}
        >
          <Popup.Header title={popupTitle} />
          <Popup.Body>
            <div className='izenda-OperatorValueCheckBoxPopup'>
              <ScrollBox>
                <GridLayout>
                  {chunkOptions.map(function(item, index) {
                    return (
                      <GridLayout.Row key={index} className='u_noMarginAll'>
                        {item}
                      </GridLayout.Row>
                    );
                  })}
                </GridLayout>
              </ScrollBox>
            </div>
          </Popup.Body>
          <Popup.Footer>
            <Popup.ConfirmationButton type='accept'>{localizer.getText('COMMON_LABEL_OK')}</Popup.ConfirmationButton>
            <Popup.ConfirmationButton type='cancel'>
              {localizer.getText('COMMON_LABEL_CANCEL')}
            </Popup.ConfirmationButton>
          </Popup.Footer>
        </Popup>
      );
    }
  });

  module.exports = OperatorValueCheckBoxPopup;
})();



// WEBPACK FOOTER //
// ./ui/modules/OperatorValue/Izenda.OperatorValueCheckBoxPopup.jsx